import {WixSdk} from 'js-sdk-wrapper';

export function getInstanceId() {
  /* global WMP */
  try {
    return WMP.wixUtils.getInstanceId();
  } catch (ex) {
    return '';
  }
}

export function getBiToken() {
  try {
    return WMP.wixUtils.getBiToken();
  } catch (ex) {
    return '';
  }
}

function openPopupOrModal(opener) {
  WixSdk.getBoundingRectAndOffsets()
    .then(rectAndOffsets => {
      const offsets = rectAndOffsets.offsets;
      const rect = rectAndOffsets.rect;

      function restoreScroll() {
        WixSdk.scrollTo(offsets.x, offsets.y - rect.top);
      }

      opener(restoreScroll);
    });
}

// eslint-disable-next-line max-params
export function openPopup(path, width, height, callback, theme) {
  let opener = function (restoreScroll) {
    WixSdk.openPopup(path, width, height, {
      origin: WixSdk.WindowOrigin.FIXED,
      placement: WixSdk.WindowPlacement.CENTER
    }, function () {
      callback.apply(null, arguments);
      restoreScroll();
    }, theme);
  };

  if (WixSdk.Utils.getDeviceType() === 'mobile') {
    opener = function (restoreScroll) {
      WixSdk.openModal(path, width, height, function () {
        callback.apply(null, arguments);
        restoreScroll();
      }, theme);
    };
  }
  openPopupOrModal(opener);

}

// eslint-disable-next-line max-params
export function openModal(path, width, height, callback, theme) {
  const opener = function (restoreScroll) {
    WixSdk.openModal(path, width, height, theme)
      .then((...args) => {
        callback(...args);
        restoreScroll();
      });
  };
  openPopupOrModal(opener);
}

export function scrollToPlayer() {
  WixSdk.getBoundingRectAndOffsets().then(rectAndOffsets => {
    const offsets = rectAndOffsets.offsets;
    WixSdk.scrollTo(offsets.x, offsets.y - 20); // 20 to look better
  });
}



// WEBPACK FOOTER //
// ./utils/wix-sdk.ts